import { dataLoader } from "@amcharts/amcharts4/core";
import {
  DATA_CONTROL_SNACKBAR,
  SET_DATA_CONTROL_CARD_SUMMARY,
  SET_DATA_CONTROL_DASHBOARD_SUMMARY,
  SET_DATA_CONTROL_FILES_DATA,
  SET_DATA_CONTROL_LOADER,
  SET_DATA_LOADER,
  SET_DOMAIN_AUDIT_TRAILS,
  SET_FILE_AUDIT_TRAIL,
  SET_REVOKE_FILE_IDS,
  SET_USER_AUDIT_TRAILS,
  SET_USER_LOCATION_AUDIT_TRAIL,
  SET_RESTRICTIONS_APPLIED_COUNT,
  SET_APPLIED_ACTIONS,
  CLEAR_APPLIED_ACTIONS,
  SET_DATA_CONTROL_CARD_SUMMARY_COUNT,
  SET_DATA_CONTROL_RISK_SCORE,
} from "../DataControlConstans";

const emptyCategoryCache = () => ({
  summary: {},
  items: [],
  loadedCount: 0,
});

const emptyAuditTrail = () => ({
  rows: [],
  total: 0,
  page: 0,
  pageSize: 10,
});

const initialState = {
  cardSummary: {},
  dashboardSummary: {},
  riskScore: {},
  cardSummaryCount: {},
  loader: false,
  dataLoader: false,
  restrictionsAppliedCount: {},
  dataControlFilesData: {},

  selectedRevokeFileIds: [],
  fileAuditTrail: emptyAuditTrail(),
  userAuditTrail: emptyAuditTrail(),
  domainAuditTrail: emptyAuditTrail(),
  userLocationAuditTrail: emptyAuditTrail(),
  appliedActions: {},

  dataControlSnackbar: {
    success: "",
    successMessage: "",
    failure: "",
    failureMessage: "",
  },
};

export default function dataControlReducer(state = initialState, action) {
  switch (action.type) {
    case SET_DATA_CONTROL_CARD_SUMMARY:
      return {
        ...state,
        cardSummary: {
          ...state.cardSummary,
          [action.payload.cardName]: action.payload,
        },
      };

    case SET_DATA_CONTROL_CARD_SUMMARY_COUNT:
      return {
        ...state,
        cardSummaryCount: {
          ...state.cardSummaryCount,
          [action.payload.cardName]: action.payload.count,
        },
      };

    case SET_DATA_CONTROL_DASHBOARD_SUMMARY:
      return {
        ...state,
        dashboardSummary: action.payload,
      };

    case SET_DATA_CONTROL_RISK_SCORE:
      return {
        ...state,
        riskScore: action.payload || {},
      };

    case SET_DATA_CONTROL_LOADER:
      return {
        ...state,
        loader: action.payload,
      };

    case SET_DATA_CONTROL_FILES_DATA: {
      const { categoryId, items, summary } = action.payload;

      if (!categoryId) return state;

      const prevCategory =
        state.dataControlFilesData[categoryId] || emptyCategoryCache();
      const nextCategory = {
        ...prevCategory,
        summary,
        items,
        loadedCount: items.length,
      };

      return {
        ...state,
        dataControlFilesData: {
          ...state.dataControlFilesData,
          [categoryId]: nextCategory,
        },
      };
    }

    case SET_DATA_LOADER:
      return {
        ...state,
        dataLoader: action.payload,
      };

    case SET_REVOKE_FILE_IDS:
      return {
        ...state,
        selectedRevokeFileIds: action.payload,
      };

    case SET_FILE_AUDIT_TRAIL:
      return {
        ...state,
        fileAuditTrail: action.payload,
      };

    case SET_USER_AUDIT_TRAILS:
      return {
        ...state,
        userAuditTrail: action.payload,
      };

    case SET_DOMAIN_AUDIT_TRAILS:
      return {
        ...state,
        domainAuditTrail: action.payload,
      };

    case SET_RESTRICTIONS_APPLIED_COUNT: {
      const { categoryId, count } = action.payload;
      if (!categoryId) return state;

      return {
        ...state,
        restrictionsAppliedCount: {
          ...state.restrictionsAppliedCount,
          [categoryId]: count,
        },
      };
    }

    case SET_USER_LOCATION_AUDIT_TRAIL:
      return {
        ...state,
        userLocationAuditTrail: action.payload,
      };

    case DATA_CONTROL_SNACKBAR:
      return {
        ...state,
        dataControlSnackbar: action.payload,
      };
    case SET_APPLIED_ACTIONS: {
      const { categoryId, ids = [], label } = action.payload || {};
      if (!categoryId || ids.length === 0) return state;

      const next = { ...(state.appliedActions[categoryId] || {}) };
      ids.forEach((id) => {
        if (id === null || id === undefined) return;
        next[String(id)] = label;
      });

      return {
        ...state,
        appliedActions: { ...state.appliedActions, [categoryId]: next },
      };
    }

    case CLEAR_APPLIED_ACTIONS: {
      const { categoryId } = action.payload || {};
      if (!categoryId) return { ...state, appliedActions: {} };

      const next = { ...state.appliedActions };
      delete next[categoryId];
      return { ...state, appliedActions: next };
    }

    default:
      return state;
  }
}